import React from 'react';
import { Chip } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RemoveIcon from '@mui/icons-material/Remove';
import { SortType } from './types';

type TextureSortProps = {
  sort: SortType;
  setSort: (sort: SortType) => void;
};

export const TextureSort: React.FC<TextureSortProps> = ({ sort, setSort }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '10px',
        marginBottom: '4px',
        gap: '8px',
      }}
    >
      <Chip
        avatar={
          sort.includes('name') ? (
            <>{sort === 'descending_name' ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}</>
          ) : (
            <RemoveIcon />
          )
        }
        label="Nom"
        onClick={() => {
          if (sort === 'ascending_name') {
            setSort('descending_name');
          } else {
            setSort('ascending_name');
          }
        }}
      />
      <Chip
        avatar={
          sort.includes('price') ? (
            <>{sort === 'descending_price' ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}</>
          ) : (
            <RemoveIcon />
          )
        }
        label="Prix M3"
        onClick={() => {
          if (sort === 'ascending_price') {
            setSort('descending_price');
          } else {
            setSort('ascending_price');
          }
        }}
      />
    </div>
  );
};
